/** A Pluma multi-select's change value as the id list a filter holds: null clears it. */
export function toIdList(value: string | string[] | null): string[] {
  if (value == null || value === '') {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}
